export function buildQueryParameterWithObject(params: { [name: string]: string }) {
  return buildQueryParameter(Object.entries(params));
}

export function buildQueryParameter(params: [string, string][]) {
  const query = new URLSearchParams();
  for (const [name, value] of params) {
    query.append(name, value);
  }
  return query.toString();
}
